import { Controller } from "@hotwired/stimulus"

// Handles shift code selection with custom code input fallback
export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "Enter code..." }
  }

  changed() {
    const select = this.element
    if (select.value === "__custom__") {
      const input = document.createElement("input")
      input.type = "text"
      input.name = select.name
      input.className = select.className
      input.placeholder = this.placeholderValue
      input.required = true
      select.replaceWith(input)
      input.focus()
    }
  }
}
